"use client"

import { ComponentConfig } from "@measured/puck"
import { twMerge } from "tailwind-merge"
import { CommonStylesProps } from "../../lib/commonCSSProps"
import { generateResponsiveCSS } from "../../lib/helper"

export interface EmbedHtmlProps extends CommonStylesProps {
  htmlContent: string
  customCss?: string
  customJs?: string
  wrapperClassName?: string
  wrapperTag?: "div" | "section" | "article" | "aside" | "main" | "span"
}

export const RenderConfig: ComponentConfig<EmbedHtmlProps> = {
  render: ({
    htmlContent,
    customCss,
    customJs,
    wrapperClassName,
    wrapperTag,
    className,
    styles,
    responsiveType,
  }) => {
    const id = `embed-html-${Math.random().toString(36).substr(2, 9)}`
    const mergedStyles = styles || {}
    const responsiveCSS = generateResponsiveCSS(id, mergedStyles, responsiveType || "mobileFirst")

    const Tag = wrapperTag || "div"

    return (
      <>
        {responsiveCSS}
        {customCss && <style dangerouslySetInnerHTML={{ __html: customCss }} />}
        {customJs && <script dangerouslySetInnerHTML={{ __html: customJs }} />}
        <Tag
          id={id}
          className={twMerge(id, wrapperClassName, className)}
          dangerouslySetInnerHTML={{ __html: htmlContent || "" }}
        />
      </>
    )
  },
}
